import { useState, FormEvent } from 'react';

export default function MeetingForm() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    tipoServico: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nome', formData.nome);
      formBody.append('email', formData.email);
      formBody.append('telefone', formData.telefone);
      formBody.append('empresa', formData.empresa);
      formBody.append('tipoServico', formData.tipoServico);
      formBody.append('mensagem', formData.mensagem);

      const response = await fetch('https://readdy.ai/api/form/d5hv02jgekujqjrtsr30', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          empresa: '',
          tipoServico: '',
          mensagem: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="reuniao" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Agende uma Reunião</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Vamos Conversar Sobre o Seu Projeto
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Preencha o formulário abaixo e a nossa equipa entrará em contato consigo para agendar uma reunião
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <form id="meeting-form" onSubmit={handleSubmit} data-readdy-form>
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="nome" className="block text-sm font-semibold text-gray-900 mb-2">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  required
                  value={formData.nome}
                  onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition-all"
                  placeholder="O seu nome"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition-all"
                  placeholder="seuemail@exemplo.com"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="telefone" className="block text-sm font-semibold text-gray-900 mb-2">
                  Telemóvel *
                </label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  required
                  value={formData.telefone}
                  onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition-all"
                  placeholder="912 345 678"
                />
              </div>
              <div>
                <label htmlFor="empresa" className="block text-sm font-semibold text-gray-900 mb-2">
                  Empresa / Projeto
                </label>
                <input
                  type="text"
                  id="empresa"
                  name="empresa"
                  value={formData.empresa}
                  onChange={(e) => setFormData({ ...formData, empresa: e.target.value })}
                  className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition-all"
                  placeholder="Nome da empresa"
                />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="tipoServico" className="block text-sm font-semibold text-gray-900 mb-2">
                Tipo de Serviço *
              </label>
              <select
                id="tipoServico"
                name="tipoServico"
                required
                value={formData.tipoServico}
                onChange={(e) => setFormData({ ...formData, tipoServico: e.target.value })}
                className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition-all cursor-pointer"
              >
                <option value="">Selecione um serviço</option>
                <option value="Implementação Chave-na-Mão">Implementação Chave-na-Mão</option>
                <option value="Procedimentos Legais">Procedimentos Legais</option>
                <option value="Projetos de Arquitetura">Projetos de Arquitetura</option>
                <option value="Formação de Equipas">Formação de Equipas</option>
                <option value="Criação de Marca">Criação de Marca</option>
                <option value="Comunicação Digital">Comunicação Digital</option>
                <option value="Suporte Jurídico">Suporte Jurídico</option>
                <option value="Outro">Outro</option>
              </select>
            </div>

            <div className="mb-6">
              <label htmlFor="mensagem" className="block text-sm font-semibold text-gray-900 mb-2">
                Mensagem
              </label>
              <textarea
                id="mensagem"
                name="mensagem"
                rows={5}
                maxLength={500}
                value={formData.mensagem}
                onChange={(e) => setFormData({ ...formData, mensagem: e.target.value })}
                className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none transition-all resize-none"
                placeholder="Conte-nos mais sobre o seu projeto e como podemos ajudar..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-2">Máximo 500 caracteres</p>
            </div>

            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center gap-3">
                <i className="ri-checkbox-circle-line text-2xl text-green-600"></i>
                <p className="text-sm text-green-800">
                  Obrigado! A sua mensagem foi enviada com sucesso. Entraremos em contato em breve.
                </p>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg flex items-center gap-3">
                <i className="ri-error-warning-line text-2xl text-red-600"></i>
                <p className="text-sm text-red-800">
                  Ocorreu um erro ao enviar a mensagem. Por favor, tente novamente.
                </p>
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-teal-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-teal-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              {isSubmitting ? (
                <>
                  <i className="ri-loader-4-line animate-spin"></i>
                  A Enviar...
                </>
              ) : (
                <>
                  Enviar Pedido
                  <i className="ri-send-plane-line"></i>
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}